import React from 'react';
import { useSelector } from 'react-redux';
import { Chip } from '@mui/material';
import { withRouter } from 'react-router-dom'
import { i18n } from '../../../../../translate/i18n';
import { Container } from './card.style'

const FutureServiceCard = props => {

  const isSuperAdmin = useSelector(state => state.auth.superadmin);

  const data = props.payload.payload;
  const goToEquipment = (equipmentId) => {
    props.history.push(`/form-equip/${equipmentId}/calendar`)
  }

  return (
    <Container style={ styles.container } stage={props.stage} onClick={() => goToEquipment(data.equipment._id)}>
      <div style={styles.titleContainer}>
        <div style={styles.equipmentName}>{data.equipmentModel.name}</div>
        { isSuperAdmin && <Chip label="FutureService" color="primary" />}
      </div>
      <div style={styles.descriptionContainer}>
        <span>{data.equipment.description}</span>
        <span>{data.equipment.serialNumber}</span>
      </div>
      <div style={styles.dataContainer}>
        <div style={styles.label}>{i18n.t('divEquipServCard.service')}</div>
        <div style={styles.data}>{data.equipmentService.serviceType.name} ({data.equipmentService.frequency.name})</div>
      </div>
      <div style={styles.dataContainer}>
        <div style={styles.label}>{i18n.t('divEquipServCard.place')}</div>
        <div style={styles.data}>{data.equipment.place.path}</div>
      </div >
      <div style={styles.dataContainer}>
        <div style={styles.label}>{i18n.t('divEquipServCard.company')}</div>
        <div style={styles.chipsData}>{data.equipment.companies.map((company) => (<Chip
          key={company._id}
          label={company.name}
          sx={{ marginTop: '5px', cursor:'default'}}/>))}
        </div>
      </div >
      {props.stage === 'done' &&
        <div style={styles.dataContainer}>
          <div style={styles.label}>{i18n.t('divEquipServCard.label')}</div>
          <div style={styles.data}></div>
        </div>
      }
    </Container>
  );
}

const styles = {
  container: {
    cursor: 'pointer',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  equipmentName: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  label: {
    color: "#828282",
    fontSize: "0.8rem"
  },
  dataContainer: {
    marginTop: 10
  },
  data: {
    marginTop: -3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    direction: 'rtl',
    textAlign: 'left'
  },
  chipsData: {
    marginTop: -3,
    display: 'flex',
    flexDirection: 'column',
  },
  filterChip: {
    margin: 5,
  },
}


export default withRouter(FutureServiceCard);

